var rb = require('crypto').randomBytes;
module.exports = function() {
  return rb(16);
};



//////////////////
// WEBPACK FOOTER
// ./~/ganache-core/~/uuid/rng.js
// module id = 1399
// module chunks = 0 1 2